import * as React from 'react';
import { useCartStore } from 'src/hooks/cart';
import System from 'src/helper/system';

const ClearCart = (props) => {
    const [{ CART_DATA }, { }, { }] = useCartStore();
    const { translation:t } = System;

    return (
        <>
            {((Object.entries(CART_DATA)?.length > 0)) &&
                <div className="bs5 row">
                    <div className="col-12 text-end">
                        <a style={{ cursor: 'pointer' }} className="text-blue" data-toggle="modal" data-target="#CartClearAll"
                            onClick={() => {
                                System.popup('ClearCartPopup')
                            }}><b>{t('clearCart')}</b></a>
                    </div>
                </div>
            }
        </>
    );
};

export default ClearCart;